import React, { useEffect, useMemo, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Drawer, Space, Tag, Form } from '@bedrock/components';
import classNames from 'classnames/bind';

import PrePaymentDetail from './PrePaymentDetail'
import { renderActions } from './Actions';
import { parseQuery } from '@mpc/common/src/utils';
import usePrepaymentList from '@mpc/common/src/model/List/PrepaymentList';
import usePrepayment from '@mpc/common/src/model/Prepayment';
import { useSForm } from '@bedrock/eed-react';
import { TagColor } from '@bedrock/components/lib/Tag';

import styles from './index.less';

const cx = classNames.bind(styles);

export const stateNameColorMap: Record<number, TagColor> = {
  1: 'orange',
  2: 'brand',
  3: 'brand',
  4: "brand",
  5: 'green',
  6: 'grey' as TagColor,
};

const PrePaymentDetailDrawer = () => {
  const { detail, loadDetail, closeDetail } = usePrepayment();
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const { refreshList } = usePrepaymentList();
  const history = useHistory();
  const { form, formData, updateFormData } = useSForm();
  const search = parseQuery(location.search);
  
  useEffect(() => {
    form.resetFields();
    form.setFieldsValue(detail);
  }, [detail]);

  useEffect(() => {
    if (search?.projectId) {
      loadDetail(+search?.projectId);
      setVisible(true);
    } else {
      setVisible(false);
      closeDetail();
      refreshList();
    }
  }, [location.search]);

  const handleClose = () => {
    history.push({ search: '' });
  };

  const drawerWidth = useMemo(() => {
    const width80 = window.innerWidth * 0.8;
    return width80 > 960 ? width80 : 960;
  }, [window.innerWidth]);

  return (
    <Drawer
      className={cx('prepayment-detail-drawer')}
      visible={visible}
      onClose={handleClose}
      width={drawerWidth}
      bodyClassName={cx('prepayment-detail-drawer-body')}
      style={{ right: 0 }}
      zIndex={100}
      getContainer={false}
      maskStyle={{ backgroundColor: 'transparent' }}
      showMask
      destroyOnClose
      title={<div className={cx('detail-title')}>
        <Space size={6} >
          <span>
            预付单：#{detail?.base_info?.prepayment_no || ''}
          </span>
          <Tag
            size="small"
            text={detail?.base_info?.status_desc}
            color={
              `light-${stateNameColorMap[detail?.base_info?.status] || 'brand'}` as TagColor
            }
          />
        </Space>
      </div>}
      footer={renderActions(detail, form)}
    >
      <div className={cx('drawer-content-wrapper')}>
        <div className={cx('drawer-content-outer')}>
          <Form
            form={form}
            layout="vertical"
            onValuesChange={(values, allValues) => {
              if (!!values?.invoice_info?.invoice_belong_area) {
                form.setFieldValue(['invoice_info', 'is_oversea_invoice'], values?.invoice_info?.invoice_belong_area !== 1)
              }
              updateFormData();
            }}>
            <PrePaymentDetail form={form} formData={formData} setFormData={updateFormData} />
          </Form>
        </div>
      </div>
    </Drawer>
  );
};

export default PrePaymentDetailDrawer;
